import React from "react";
import styles from "./styles.module.scss";

interface DropdownSelectProps {
  options: string[];
  defaultLabel?: string;
  onSelect?: (value: string) => void;
  className?: string;
}

const DaysSelect: React.FC<DropdownSelectProps> = ({
  options,
  defaultLabel = "Select an option",
  onSelect,
  className,
}) => {
  const [value, setValue] = React.useState("");

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onSelect?.(newValue);
  };

  return (
    <div className={`${styles.dropdownContainer} ${className || ""}`}>
      <select
        className={styles.customSelect}
        value={value}
        onChange={handleChange}
        aria-label={defaultLabel}
      >
        <option value="" disabled>
          {defaultLabel}
        </option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DaysSelect;
